var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEncEncColourEnc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 397.01 142.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.67,
    y1: 28.1472,
    x2: -9.2569,
    y2: 117.0223
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M33.1,112.92h74.56v24.42H4.97V4.87h96.4v24.42H33.1v29.79h60.32V84.8H33.1V112.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181777745854922492450000006513728866570856843_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.3743,
    y1: 24.1533,
    x2: -14.9612,
    y2: 121.0169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181777745854922492450000006513728866570856843_)"
    },
    d: "M112.66,142.35H-0.03V-0.13h106.4v34.42 H38.1v19.79h60.32V89.8H38.1v18.12h74.56V142.35z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083070995805732910260000009024219041024471198_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.5384,
    y1: 22.1247,
    x2: 116.0493,
    y2: 120.4962
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083070995805732910260000009024219041024471198_)"
    },
    d: "M153.25,46.29v91.2h-25.29V5.12h33.23 l58.89,82.34V5.12h24.55V137.5h-24.55L153.25,46.29z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142172060382077062930000013327385380037238678_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.2428,
    y1: 18.1304,
    x2: 110.3453,
    y2: 124.4902
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142172060382077062930000013327385380037238678_)"
    },
    d: "M249.63,142.5h-32.09l-59.3-80.92v80.92 h-35.29V0.12h40.8l51.32,71.76V0.12h34.55V142.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075852977720590172290000011541327652787680177_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.2794,
    y1: 33.5699,
    x2: 277.8719,
    y2: 109.4776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075852977720590172290000011541327652787680177_)"
    },
    d: "M331.96,137.5 c-36.57,0-66.19-29.62-66.19-66.19c-1.25-66.95,92.91-90.94,123.6-32.36c-11.15,5.85-12.07,6.4-24.5,12.43 c-18.44-33.36-72.5-18.56-71.67,19.93c-0.76,39.5,55.05,53.45,72.77,18.46c12.43,6.4,12.8,7.13,24.5,12.43 C379.32,123.24,357.74,137.5,331.96,137.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049901871307712969150000016848029265763428753_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.4468,
    y1: 30.5935,
    x2: 273.7782,
    y2: 112.2857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049901871307712969150000016848029265763428753_)"
    },
    d: "M331.96,142.5 c-39.25,0-71.19-31.93-71.19-71.19c-0.84-74.73,104.22-98.15,135.47-30.32c-11.53,6.09-19.73,10.39-33.39,16.93 c-14.52-33.16-64.56-22.93-64.66,13.39c0.27,37.43,52.2,46.48,65.66,11.76c12.55,6.38,19.93,10.88,33.52,16.78 C385.39,125.81,360.69,142.7,331.96,142.5z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncEncColourEnc);
export default __webpack_public_path__ + "static/media/enc_ENC-colour_ENC.ad2131f0726ca29015d45f837285b17f.svg";
export { ForwardRef as ReactComponent };